import { Vue } from "vue-property-decorator";
import { MutationTree } from "vuex";

import { ICommonState } from "./common-states.store";

import { AuthVerified, AuthTransfer } from "../../models/generic/auth-transfer";
import { INavbar } from "../../models/app-configuration";
import { COMMON_LOOKUP_TYPE, default as StoreTypes, COMMON_ROUTER_MANAGER, COMMON_MESSAGE_NOTIFICATION, QuickViewPropsModel, OpenAppointmentPropsModel } from "../types";
import { IPersonAutoComplete } from "../../models/autocomplete";
import { IRouteTab } from "../../models/common/route-tab.model";

import { IRouterHelper } from "../../models/router";
import { IMessageNotificationParameterModel } from "../../models/message-notification/index";
import { SetPrintTemplateModalVisibleParamModel } from "../../models/report/report-print-template.model";
import { IAgendaPrefetchInfoDetail } from "../../models/agenda/appointment.model";
import { ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG } from "../../common/constants";
import { IDrawerModel } from "../../models/common/drawer.model";
import { IUploadCommon } from "../../models/common/upload-file-model";
import { STATUS_INITIAL, STATUS_SAVING } from "../../common/upload-state";

const mutations: MutationTree<ICommonState> = <MutationTree<ICommonState>>{
    [StoreTypes.Set.PAGEACTIVE]: (state, navbar: INavbar) => {
        state.navbar = navbar;
    },

    [StoreTypes.Set.HORIZONTALPAGE]: (state, isHorizontalPage: boolean) => {
        state.isHorizontalPage = isHorizontalPage;
    },

    [StoreTypes.Set.PAGEREADY]: (state, isPageRendered: boolean) => {
        state.isPageRendered = isPageRendered;
    },

    [StoreTypes.Set.SET_LOADING_PAGE]: (state, payload: boolean) => {
        state.loading = payload;
    },
    [StoreTypes.Set.SET_STREAMING_PAGE]: (state, payload: boolean) => {
        state.streaming = payload;
    },

    [StoreTypes.Set.USERSESSION]: (state, session: { config: AuthTransfer; userInfo: AuthVerified }) => {
        state.userSession = session.userInfo;
        state.authTransfer = session.config;
    },

    [StoreTypes.Set.IS_OPEN_MODAL]: (state, isOpenModal: boolean) => {
        state.isOpenModal = isOpenModal;
    },
    [StoreTypes.Set.PREV_QUERY]: (state: ICommonState, query: string) => {
        state.previousQuery = query;
    },
    [StoreTypes.Set.PLACE_SUGGESTION]: (
        state: ICommonState,
        listOfPlaces: string[]
    ) => {
        state.listOfPlaces = listOfPlaces;
    },
    [StoreTypes.Set.PREV_QUERY_PEOPLE]: (state: ICommonState, query: string) => {
        state.previousQueryPeople = query;
    },
    [StoreTypes.Set.LIST_OF_PEOPLE]: (
        state: ICommonState,
        listOfPeople: IPersonAutoComplete[]
    ) => {
        state.listOfPeople = listOfPeople;
    },
    [StoreTypes.Set.MAPOPTIONS]: (state: ICommonState, mapOptions) => {
        state.mapOptions = mapOptions;
    },
    [StoreTypes.Set.MAPREGIONS]: (state: ICommonState, mapRegions) => {
        state.mapRegions = mapRegions;
    },
    [StoreTypes.Set.TYPE_OF_PROPERTY_ID]: (
        state: ICommonState,
        typeOfPropertyId: number
    ) => {
        state.prevTypeOfPropertyId = typeOfPropertyId;
    },
    [StoreTypes.Set.GRID_CONFIGS_PROPERTY]: (
        state: ICommonState,
        payload: any
    ) => {
        state.gridConfigsProperties = payload;
    },
    [StoreTypes.Set.GRID_CONFIGS_PERSON]: (state: ICommonState, payload: any) => {
        state.gridConfigsPersons = payload;
    },
    [StoreTypes.Set.GRID_CONFIGS_DEMAN]: (state: ICommonState, payload: any) => {
        state.gridConfigsDemands = payload;
    },
    [StoreTypes.Set.GRID_CONFIGS_TASK]: (state: ICommonState, payload: any) => {
        state.gridConfigsTasks = payload;
    },
    [StoreTypes.Set.PERSON_MERGE_DATA_TEMP]: (state: ICommonState, payload: { destinationId: number, data: any, originId: number }) => {
        state.personMergeDataTemp = payload;
    },
    [COMMON_LOOKUP_TYPE.SET_COMMON_VISITED_VIEWS]: (state: ICommonState, payload: IRouteTab) => {
        if (state.visitedViews.some(view => (view.fullPath.replace(/\/$/g, "") === payload.fullPath.replace(/\/$/g, "")))) return;
        state.visitedViews.push(payload);
    },
    [COMMON_LOOKUP_TYPE.DELETE_COMMON_VISITED_VIEWS]: (state: ICommonState, payload: { route: IRouteTab, index: number }) => {
        let index = state.visitedViews.findIndex(item => item.fullPath.replace(/\/$/g, "") === payload.route.fullPath.replace(/\/$/g, ""));
        if (index > -1) {
            state.visitedViews.splice(index, 1);
        }
    },
    [COMMON_LOOKUP_TYPE.UPDATE_COMMON_VISITED_VIEWS]: (state: ICommonState, payload: IRouteTab) => {
        let index = state.visitedViews.findIndex(item => item.fullPath.replace(/\/$/g, "") === payload.fullPath.replace(/\/$/g, ""));
        if (index > -1) Vue.set(state.visitedViews, index, payload);

	},
	[COMMON_LOOKUP_TYPE.GET_CONSULTED_NEXT_PERSON]: (state: ICommonState, payload: Array<any>) => {
		state.consultedNextPerson = payload;
	},
	[COMMON_ROUTER_MANAGER.UPDATE_LIST_ROUTER]: (state: ICommonState, payload: { route: IRouterHelper }) => {
		state.routerList.push(payload.route);
		state.routeLevel = state.routerList.length;
	},
	[COMMON_ROUTER_MANAGER.REMOVE_LIST_ROUTER]: (state: ICommonState) => {
		if (state.routerList.length > 0) {
			state.routerList.pop();
			state.routeLevel = state.routeLevel - 1;
		}
	},
	[COMMON_ROUTER_MANAGER.CLEAR_LIST_ROUTER]: (state: ICommonState) => {
		state.routerList = [];
		state.routeLevel = 0;
	},
	[COMMON_MESSAGE_NOTIFICATION.SET_FILTER]: (state: ICommonState, payload: IMessageNotificationParameterModel) => {
		Object.keys(payload).forEach(key => {
			if (key in state.filterMessageNotification) {
				Vue.set(state.filterMessageNotification, key, payload[key])
			};
		});
	},
	[COMMON_MESSAGE_NOTIFICATION.SET_MARK_READ]: (state: ICommonState, payload: number[]) => {
		state.markReadMessageNotificationIds = state.markReadMessageNotificationIds || [];
		(payload || []).forEach(id => {		
			if (state.markReadMessageNotificationIds.find(x => x == id) === undefined) {
				state.markReadMessageNotificationIds.push(id);
			};
		});
	},
	[COMMON_MESSAGE_NOTIFICATION.REMOVE_MARK_READ]: (state: ICommonState, payload: number[]) => {
		state.markReadMessageNotificationIds = state.markReadMessageNotificationIds || [];
		(payload || []).forEach(id => {		
			const index = state.markReadMessageNotificationIds.indexOf(id, 0);
			if (index > -1) {
				state.markReadMessageNotificationIds.splice(index, 1);
			}
		});
	},
	[COMMON_MESSAGE_NOTIFICATION.CLEAR_ALL_MARK_READ]: (state: ICommonState) => {
		state.markReadMessageNotificationIds = [];		
	},
	setSendMessageModalVisible: (state: ICommonState, payload: SetPrintTemplateModalVisibleParamModel) => {
		state.sendMessageModalVisible = payload.visible;
		if (payload.visible) {
			state.sendMessageModalProps = payload.props || {};
		} else {
			state.sendMessageModalProps = {};
		}
	},
    setSendSMSModalVisible: (state: ICommonState, payload: SetPrintTemplateModalVisibleParamModel) => {
		state.sendSMSModalVisible = payload.visible;
		if (payload.visible) {
			state.sendSMSModalProps = payload.props || {};
		} else {
			state.sendSMSModalProps = {};
		}
	},
	setLargeMailingModalVisible: (state: ICommonState, payload: SetPrintTemplateModalVisibleParamModel) => {
		state.largeMailingModalVisible = payload.visible;
		// if (payload.visible) {
		// 	state.sendMessageModalProps = payload.props || {};
		// } else {
		// 	state.sendMessageModalProps = {};
		// }
    },
    [COMMON_LOOKUP_TYPE.GET_CONSULTED_NEXT_PERSON]: (state: ICommonState, payload: Array<any>) => {
        state.consultedNextPerson = payload;
    },
    [COMMON_ROUTER_MANAGER.UPDATE_LIST_ROUTER]: (state: ICommonState, payload: { route: IRouterHelper }) => {
        state.routerList.push(payload.route);
        state.routeLevel = state.routerList.length;
    },
    [COMMON_ROUTER_MANAGER.REMOVE_LIST_ROUTER]: (state: ICommonState) => {
        if (state.routerList.length > 0) {
            state.routerList.pop();
            state.routeLevel = state.routeLevel - 1;
        }
    },
    [COMMON_ROUTER_MANAGER.CLEAR_LIST_ROUTER]: (state: ICommonState) => {
        state.routerList = [];
        state.routeLevel = 0;
    },
    [COMMON_MESSAGE_NOTIFICATION.SET_FILTER]: (state: ICommonState, payload: IMessageNotificationParameterModel) => {
        Object.keys(payload).forEach(key => {
            if (key in state.filterMessageNotification) {
                Vue.set(state.filterMessageNotification, key, payload[key])
            };
        });
    },    
    setVisibleDrawerModel: (state: ICommonState, payload: IDrawerModel) => {
        state.drawerModels.push(payload);
    },
    closeCurrentDrawerModel: (state: ICommonState) => {
        state.drawerModels.splice(-1, 1);
    },
    closeAllDrawerModel: (state: ICommonState) => {
        state.drawerModels = [];
    },
    setPrintTemplateModalVisible: (state: ICommonState, payload: SetPrintTemplateModalVisibleParamModel) => {
        state.printTemplateModalVisible = payload.visible;
        if (payload.visible) {
            state.printTemplateModalProps = payload.props || {};
        } else {
            state.printTemplateModalProps = {};
        }
    },
    setQuickViewObjectProps: (state, payload: QuickViewPropsModel) => {
        state.quickViewObjectProps = payload;
        if (payload) state.openAppointmentModalProps = null;
    },
    [COMMON_LOOKUP_TYPE.GET_GRID_CONFIG_USED_USERS]: (state, payload: { key: string, value: any }) => {
        Vue.set(state.gridConfigsUsedUsers, payload.key, payload.value)
    },
    setNotificationMessage: (state, payload) => {
        state.notificationMessage = payload;
    },
    setVisibleConflictDataInfo: (state, payload) => {
        state.conflictDataInfoVisible = payload;
    },
    setUserChangeDataFields: (state, payload) => {
        state.userChangeDataFields = payload;
    },
    setOpenAppointmentProps: (state, payload: OpenAppointmentPropsModel) => {
        state.openAppointmentModalProps = payload;
        if (payload) state.quickViewObjectProps = null;
    },
    setAgendaPrefetchInfo: (state, payload: { key: string, data: IAgendaPrefetchInfoDetail }) => {
        state.agendaPrefetchInfo[payload.key] = payload.data;
    },
    resetAgendaPrefetchInfo: (state, key) => {
        if (key) {
            switch (key) {
                case 'propertyInfo':
                    state.agendaPrefetchInfo[key] = null;
                    state.agendaPrefetchInfo.managerInfo.propertyManager = null;
                    break;
                case 'personInfo':
                    state.agendaPrefetchInfo[key] = null;
                    state.agendaPrefetchInfo.managerInfo.personManager = null;
                    break;
                case 'managerInfo':
                    state.agendaPrefetchInfo[key] = {};
                    break;
            }
        } else {
            state.agendaPrefetchInfo = {};
        }
    },
    setAgendaPrefetchPersonManager: (state, payload: { configValue: number, managerId?: number }) => {
        state.agendaPrefetchInfo.managerInfo = state.agendaPrefetchInfo.managerInfo || {
            config: ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.DO_NOT_ADD
        };
        switch (payload.configValue) {
            case ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.DO_NOT_ADD:
                state.agendaPrefetchInfo.managerInfo.personManager = null;
                break;
            case ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.AUTO_ADD_TO_RESOURCE:
                state.agendaPrefetchInfo.managerInfo.personManager = payload.managerId;
                state.agendaPrefetchInfo.managerInfo.config = ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.AUTO_ADD_TO_RESOURCE;
                break;
            case ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.SET_MANAGER_BE_RESOURCE:
                state.agendaPrefetchInfo.managerInfo.personManager = payload.managerId;
                state.agendaPrefetchInfo.managerInfo.propertyManager = null;
                state.agendaPrefetchInfo.managerInfo.config = ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.SET_MANAGER_BE_RESOURCE;
                break;
        }
    },
    setAgendaPrefetchPropertyManager: (state, payload: { configValue: number, managerId?: number }) => {
        state.agendaPrefetchInfo.managerInfo = state.agendaPrefetchInfo.managerInfo || {
            config: ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.DO_NOT_ADD
        };
        switch (payload.configValue) {
            case ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.DO_NOT_ADD:
                state.agendaPrefetchInfo.managerInfo.propertyManager = null;
                break;
            case ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.AUTO_ADD_TO_RESOURCE:
                state.agendaPrefetchInfo.managerInfo.propertyManager = payload.managerId;
                state.agendaPrefetchInfo.managerInfo.config = ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.AUTO_ADD_TO_RESOURCE;
                break;
            case ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.SET_MANAGER_BE_RESOURCE:
                state.agendaPrefetchInfo.managerInfo.propertyManager = payload.managerId;
                state.agendaPrefetchInfo.managerInfo.personManager = null;
                state.agendaPrefetchInfo.managerInfo.config = ADD_MANAGER_TO_AGENDA_RESOURCE_CONFIG.SET_MANAGER_BE_RESOURCE;
                break;
        }
    },
    [StoreTypes.Set.WEBAPP_LAYOUT]: (state, layoutMode: string) => {
        state.webappLayoutMode = layoutMode;
    },
    initUpload: (state: ICommonState, payload: IUploadCommon) => {
        state.uploadModels.push(payload);
    },
    addFilesToUploadControl: (state: ICommonState, payload) => {
        const upload = state.uploadModels.find(x => x.Id === payload.id);
        upload.UploadFiles.push(payload.file)
    },
    updateUploadControl: (state: ICommonState, payload: IUploadCommon) => {
        const upload = state.uploadModels.find(x => x.Id === payload.Id);
        upload.Type = payload.Type;
    },
    updateFilesUploadControl: (state: ICommonState, payload) => {
        const upload = state.uploadModels.find(x => x.Id === payload.id);
        const uploadFile = upload?.UploadFiles.find(x => x.Id === payload.fileId);
        if (uploadFile) {
            uploadFile[payload.key] = payload.value;
            if (uploadFile?.Progress === 100) {
                if (uploadFile.Status === STATUS_INITIAL) {
                    uploadFile.Status = STATUS_SAVING;
                }   
            }
        }
    },
    removeFilesUploadControl: (state: ICommonState, payload) => {
        const upload = state.uploadModels.find(x => x.Id === payload.id);
        const index = upload.UploadFiles.findIndex(x => x.Id === payload.fileId);
        upload.UploadFiles.splice(index, 1);
    },
    removeUploadControl: (state: ICommonState, payload) => {
        const upload = state.uploadModels.findIndex(x => x.Id === payload.id);
        state.uploadModels.splice(upload, 1);
    },
};

export default mutations;
